import React from 'react';
import styled from 'styled-components';
import { MdiArrowDownIcon, CancelIcon, HistoryIcon } from '@increasecard/icons';
import { getDownloadLink, IconButton } from '@card/commonlib';
import { Report } from '@card/types';
import { useEventTracker } from '@increasecard/increase-core';

export const PendingIcon = styled(HistoryIcon)`
  color: ${({ theme }) => theme.colorsNew.gray.grayBold};
`;

export const ErrorIcon = styled(CancelIcon)`
  color: ${({ theme }) => theme.colorsNew.coralAlert.regular};
`;

function downloadReport(id: string) {
  return getDownloadLink({ reportId: id }).then((link) => {
    window.location.href = link;
  });
}

export function ReportActions({ status, filename, id }: Report) {
  const tracker = useEventTracker();
  switch (status) {
    case 'failed':
      return (
        <div title="Error al generar el reporte">
          <ErrorIcon height="24" width="24" />
        </div>
      );
    case 'pending':
      return (
        <div title="Reporte en proceso">
          <PendingIcon height="24" width="24" />
        </div>
      );
    case 'finished':
    default:
      return (
        <IconButton
          aria-label={`Descargar reporte ${filename}`}
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/camelcase
            tracker.track('Download report', { report_id: id });
            downloadReport(id);
          }}
          title={`Descargar reporte ${filename}`}
        >
          <MdiArrowDownIcon height="24" width="24" />
        </IconButton>
      );
  }
}
